
import * as __star__ from 'dagre';

const {
default: __default__,
graphlib,
layout,
debug,
util,
version
} = __star__;

export {
graphlib,
layout,
debug,
util,
version
};
export default __default__;
